const getters = {
    userInfo: state => state.user.userInfo,
    userDetail: state => state.user.userDetail,
    isMobileMode: state => state.device.isMobile
}

export default getters